import { render, staticRenderFns } from "./FormAggregateInfo.vue?vue&type=template&id=29a63e98"
import script from "./FormAggregateInfo.vue?vue&type=script&lang=js"
export * from "./FormAggregateInfo.vue?vue&type=script&lang=js"
import style0 from "./FormAggregateInfo.vue?vue&type=style&index=0&id=29a63e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports